import React, { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Dropdown,  Modal as AntModal, Spin } from "antd";
import { Header, TitleWrapper, Title, NameText } from "./Topbar.style";
import { useLocation, useNavigate } from "react-router-dom";
import { PRIVATE_ROUTE } from "../../route.constants";
import styled from "styled-components";
import { ProfileDown,IconMail } from "../../assets/icons";
import { localStorage } from "@utils";
import { useDispatch } from "react-redux";
import { api,Status } from "@api";
import { clearToken } from "@store/auth/authSlice";
import LanguageSwitcher from "../LanguageSwitch/LanguageSwitcher";
import { useTranslation } from "react-i18next";

const { HOME, DASHBOARD } = PRIVATE_ROUTE;

const SpinStyled = styled(Spin)`
  .ant-spin-dot-item {
    background-color: white !important;
  }
`;

const Modal = styled(AntModal)`
width: 300px !important;

    .ant-modal-body {
        text-align: center;
        padding: 20px;
    }

    .ant-modal-footer {
        text-align: center;

        button {
            width: 73px;
        }
    }
`;

const Topbar = ({ openModal }) => {
  const navigate = useNavigate();
  //   const [adminData, setAdminData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const adminData = JSON.parse(localStorage.getAdmin());
  const [data, setData] = useState(null);
  const dispatch = useDispatch();
  const [logoutStatus, setLogoutStatus] = useState(Status.DEFAULT);
  const [open, setOpen] = useState(false);

   const location = useLocation();
     const { t } = useTranslation();


  //   useEffect(() => {
  //     const adminProfile = localStorage.getItem("admin");
  //     setAdminData(JSON.parse(adminProfile));
  //   }, []);

  const items = [
    {
      key: "profile",
      label: t('view_profile'),
      onClick: () =>
        navigate(`/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.PROFILE}`),
    },
    {
      key: t('logout'),
      label: <p style={{ color: "#FF1A1A" }}>{t('logout')}</p>,
      onClick: openModal,
    },
  ];

  const goToHome = () => {
    navigate(`/${HOME}/${DASHBOARD}`);
  };

   const logout = () => {
    resetSessionState();
  };

  const resetSessionState = () => {
    // clear token in redux
    dispatch(clearToken());
    // remove token from localstorage
    localStorage.clearToken();
    // update token in request obj
    api.setSessionToken("");

    // remove admin from localstorage
    localStorage.clearAdmin();
  };


    const getBusinessInformation = () => {
  api
    .getBusinessInformation()
    .then(() => {
      setData(""); // no error
    })
    .catch((error) => {
      const errMsg = error || "";
      setData(errMsg);
      console.log("data", data)
    });
};

useEffect(() => {
  getBusinessInformation();
}, []);

useEffect(() => {
  if (data === "Unauthorized: Store is overdue.") {
    setOpen(true);
  }
}, [data,location?.pathname]);

  const MainLogo = () => (
    <TitleWrapper>
      <Title onClick={goToHome}>{t('business_admin')}</Title>
      <NameText>{adminData?.role}</NameText>
    </TitleWrapper>
  );
  const Profile = () => (
    <Dropdown
      menu={{ items }}
      trigger={["click"]}
      style={{ cursor: "pointer" }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          cursor: "pointer",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            color: "white",
            maxWidth: "120px", // Adjust based on your layout
          }}
        >
          <p
            style={{
              fontSize: "16px",
              lineHeight: "24px",
              margin: 0,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {adminData?.name ?? "Admin"}
          </p>
          {/* Optional role */}
          {/* <p
          style={{
            fontSize: "12px",
            lineHeight: "20px",
            margin: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {adminData?.role ?? "Role"}
        </p> */}
        </div>
        <ProfileDown
          style={{ cursor: "pointer", width: "20px", height: "20px" }}
        />
      </div>
    </Dropdown>
  );


  return (
    <Header>
     {/* {renderHeader()} */}
      <MainLogo />
      {isLoading ? (
        <SpinStyled
          indicator={<LoadingOutlined spin />}
          style={{ color: "white" }}
        />
      ) : (
        <>
        <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
        <Profile />
        <div onClick={() => navigate(`/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.NOTIFICATION}`)}
        style={{
          width:"48px",
          height:"48px",
          borderRadius:"8px",
          backgroundColor:"#467AFF",
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          cursor:"pointer",
        }} >
        <IconMail/>
        </div>
        <LanguageSwitcher/>
       </div>
        </>
      )}
      {data === "Unauthorized: Store is overdue." && (
        <Modal
          centered
          closable={false}
          open={open}
          confirmLoading={logoutStatus === Status.LOADING}
          // onCancel={() => logoutStatus !== Status.LOADING && setOpen(true)}
          footer={[
          <button
            key="ok"
            onClick={logout}
            disabled={logoutStatus === Status.LOADING}
            style={{
              background: "#1859ff",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              padding: "6px 16px",
              cursor: "pointer",
            }}
          >
            OK
          </button>,
        ]}
        >
          Your store is Overdue!
        </Modal>
      )}
    </Header>
  );
};

export default Topbar;
